import { Colors } from 'axl-reactjs-ui';

export default {
  panelContainer: {
    borderRadius: '5px',
    backgroundColor: '#f4f4f4',
    padding: '10px 15px',
    marginBottom: '15px'
  },
  panelHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  panelHeaderLeft: {},
  panelHeaderRight: {
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    justifyContent: 'center',
    alignItems: 'center'
  },
  panelHeaderTitle: {
    flex: 1,
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    color: '#000'
  },
  panelHeaderStatus: {
    fontSize: '12px',
    fontStyle: 'italic',
    margin: '0 5px'
  },
  wrapHeaderEdit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  rowHeaderLabel: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: "12px",
    color: "#96979a",
  },  
  panelHeaderButton: {
    margin: '0 5px'
  },
  row: {
    marginBottom: '10px'
  },
  panelHeaderArrow: {
    cursor: 'pointer',
    fontSize: 30,
    color: '#bebfc0',
    margin: '0 5px'
  },
}
